export { default as WarningIcon } from "./WarningIcon";
